module.exports = __webpack_public_path__ + "static/media/ico_error.45310cc5.svg";